import { UserService } from 'api/generated';
import { UseQueryOptions, useQuery } from 'react-query';

export const usePersonalDetailsQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  {
    uid
  }: {
    uid: string;
  },
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof UserService.getUsersPersonalDetails1>>,
      unknown,
      Awaited<ReturnType<typeof UserService.getUsersPersonalDetails1>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    ['RequestPersonalDetails', ...(queryKey ?? [{ uid }])],
    () => UserService.getUsersPersonalDetails1(uid),
    options
  );
